var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.city_code
    ? _c("li", { staticClass: "top-deals-hotel" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy:background-image",
                value: _vm.cover_img,
                expression: "cover_img",
                arg: "background-image"
              }
            ],
            staticClass: "hotel-img"
          },
          [
            _c("span", { staticClass: "hotel-img-tag" }, [
              _vm._v(_vm._s(_vm.$t("save_safe")) + " " + _vm._s(_vm.discount))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "hotel-content" },
          [
            _c("p", { staticClass: "line-text hotel-name" }, [
              _vm._v(_vm._s(_vm.hotel_name))
            ]),
            _vm._v(" "),
            _c("e-star", { attrs: { level: _vm.star ? _vm.star * 1 : 1 } }),
            _vm._v(" "),
            _vm.reviews && _vm.reviews.rate
              ? _c("div", { staticClass: "rate-line" }, [
                  _c("span", { staticClass: "rate-tag" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.reviews && (_vm.reviews.rate * 2).toFixed(1)) || ""
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "rate-text" }, [
                    _vm._v(_vm._s(_vm.rateText))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "rate-views" }, [
                    _vm._v(
                      "(" +
                        _vm._s((_vm.reviews && _vm.reviews.reviewCount) || "") +
                        " " +
                        _vm._s(_vm.$t("reviews")) +
                        ")"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.label, function(item, index) {
              return _c("hotel-tag", {
                key: index,
                attrs: { type: index % 4, text: item }
              })
            }),
            _vm._v(" "),
            _c("div", { staticClass: "location-p" }, [
              _c("i", { staticClass: "iconfont icon-location1" }),
              _vm._v("\n            " + _vm._s(_vm.fromCenter) + "\n        ")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "hotel-price" }, [
              _c("span", [_vm._v("From")]),
              _vm._v(" "),
              _c("span", { staticClass: "origin-price" }, [
                _vm._v(
                  _vm._s(_vm.unit) + _vm._s(_vm.getPrice(_vm.original_price))
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sale-price" }, [
                _vm._v(
                  _vm._s(_vm.unit) + " " + _vm._s(_vm.getPrice(_vm.sales_price))
                )
              ])
            ])
          ],
          2
        )
      ])
    : _c("li", { staticClass: "top-deals-hotel", staticStyle: { height: "0" } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-467cb3d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467cb3d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/TopDealsHotel.vue
// module id = null
// module chunks = 